import React, { useMemo, useState } from "react";
import PulseAnalytics from "./index";
import {
  transformQuestionsData,
  transformRespondentsData,
} from "./dataTransformers";
import AnalyticsBreadcrumb from "../NewAnalytics/AnalyticsBreadcrumb";
import PulseSurveyHeader from "./PulseSurveyHeader";

const PulseAnalyticsWithData = ({
  questions = [],
  responses = [],
  participants = [],
  surveyInfo = {},
  compliance = {},
  onSelectClick,
  onChatClick,
  onCloseSurvey,
  onArchiveSurvey,
  backAction,
  showHeader = false,
}) => {
  const [modalOpenFunction, setModalOpenFunction] = useState(null);

  const handleSelectClick = () => {
    if (modalOpenFunction) {
      modalOpenFunction();
    }
  };
  const transformedData = useMemo(() => {
    const hasLoadedSurveyData =
      questions.length > 0 ||
      participants.length > 0 ||
      Boolean(surveyInfo?.title) ||
      Boolean(surveyInfo?.task_template_id);

    if (!hasLoadedSurveyData) {
      return null;
    }

    const transformedQuestions = transformQuestionsData(
      questions,
      responses,
      participants
    );
    const transformedRespondents = transformRespondentsData(
      participants,
      responses,
      questions
    );

    return {
      surveyId: surveyInfo.surveyId || "pulse_001",
      surveyName: surveyInfo.title || "Employee Engagement Pulse",
      questions: transformedQuestions,
      respondents: transformedRespondents,
    };
  }, [questions, responses, participants, surveyInfo]);

  return (
    <>
      <AnalyticsBreadcrumb />
      {showHeader && (
        <PulseSurveyHeader
          title={surveyInfo.title || "Pulse Survey"}
          description={surveyInfo.description || ""}
          createdBy={surveyInfo.createdBy || ""}
          createdDate={surveyInfo.createdDate || ""}
          updatedDate={surveyInfo.updatedDate || ""}
          surveyIsAnonymous={surveyInfo.surveyIsAnonymous || false}
          surveyIsOpen={surveyInfo.surveyIsOpen || false}
          task_template_id={surveyInfo.task_template_id || 0}
          compliance={compliance}
          onSelectClick={handleSelectClick}
          onChatClick={onChatClick}
          onCloseSurvey={onCloseSurvey}
          onArchiveSurvey={onArchiveSurvey}
          backAction={backAction}
        />
      )}
      <PulseAnalytics
        pulseData={transformedData}
        surveyInfo={surveyInfo}
        isAnonymous={Boolean(surveyInfo.surveyIsAnonymous)}
        onModalOpen={(fn) => setModalOpenFunction(() => fn)}
      />
    </>
  );
};

export default PulseAnalyticsWithData;
